import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory } from 'react-router'

import { createIntegration } from '@/reducers/integrations/integrations.actions'
import { getOrganizationOptions } from '@/utils/helpers'
import { AbstractForm } from '@/components/forms/formik/AbstractForm'
import { closeModal } from '@/reducers/ui/ui.redux'

import { getSchema } from './integrations.schema'
import { creatableConnectorTypeOptions } from './helpers'

export const IntegrationsForm = () => {
  const { organizations } = useSelector((state) => state)
  const organizationOptions = getOrganizationOptions(organizations)
  const typeOptions = creatableConnectorTypeOptions

  const history = useHistory()
  const dispatch = useDispatch()
  const schema = getSchema({
    typeOptions,
    organizationOptions,
  })

  return (
    <AbstractForm
      schema={schema}
      buttonLabel="Create"
      onSubmit={({ validateOnMount, ...values }) => {
        // strip out validateOnMount prop with destructuring
        dispatch(createIntegration({ values, push: history.push }))
        dispatch(closeModal())
      }}
    />
  )
}
